import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
import TagManager from 'react-gtm-module'

function loadScript(src) {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  }

export const initPixel = () =>{
   const options = {
    autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
    debug: false, // enable logs
  };
  ReactPixel.init('663014314511621', options);
  ReactPixel.pageView(); // For tracking page view
}

export const initGA = () =>{
    ReactGA.initialize('UA-179515247-1');

    var script= document.createElement('script');
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-312869085";
    document.head.appendChild(script);

    var script= document.createElement('script');
    script.text = "window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);} gtag('js', new Date());";
    document.head.appendChild(script);

    window.gtag('config', 'AW-312869085');
    ReactGA.pageview(window.location.pathname + window.location.search);
}

export const initGA2 = () =>{

  var script= document.createElement('script');
  script.src = "https://www.googletagmanager.com/gtag/js?id=G-7V36RJZVMJ";
  document.head.appendChild(script);

  var script= document.createElement('script');
  script.text = "window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);} gtag('js', new Date());";
  document.head.appendChild(script);

  window.gtag('config', 'G-7V36RJZVMJ');
  ReactGA.pageview(window.location.pathname + window.location.search);
}

export const createjscssfile = () => {
    // var script = "https://www.googletagmanager.com/gtag/js?id=AW-312869085"
    // script.parentNode.removeChild( script );
}